import { Navigate, Outlet } from 'react-router-dom';
import {useUser} from "../../contexts/UserContext";
import Routing from "../../services/routing";

const ProtectedRouteWithRoles = ({ requiredRoles }) => {
    const { user } = useUser();

    if (!user || !requiredRoles.some(role => user.roles.includes(role))) {
        return <Navigate to={Routing.routes.unauthorized} replace />;
    }

    return <Outlet />;
};

export default ProtectedRouteWithRoles;